import * as React from 'react';
import cn from 'classnames';

import { useTheme } from '../../theme';
import CdnImage from '../../CdnImage';

interface Props {
	className?: string;
}

const TicketExample: React.FC<Props> = ({ className }) => {
	const { TicketExample: css } = useTheme('TicketExample');

	return (
		<CdnImage
			path="TicketExample.png"
			contentRepo
			className={cn(css.ticketExample, className)}
			alt="Ticket example"
		/>
	);
};

export default TicketExample;
